import type { Placement } from 'react-overlays/usePopper';
import type { TooltipAlignEnum, TooltipDirectionEnum } from './Tooltip.types';

export const PLACEMENT_TO_DIRECTION: Record<string, string> = {
  top: 'Top',
  bottom: 'Bottom',
  left: 'Left',
  right: 'Right',
};

export const PLACEMENT_TO_ALIGNMENT: Record<string, string> = {
  start: 'Start',
  end: 'End',
  center: 'Center',
};

export const TOOLTIP_VARIANT_MAP = {
  'Top-Center': 'center-top',
  'Top-Start': 'start-top',
  'Top-End': 'end-top',
  'Bottom-Center': 'center-bottom',
  'Bottom-Start': 'start-bottom',
  'Bottom-End': 'end-bottom',
  'Left-Center': 'center-left',
  'Left-Start': 'start-left',
  'Left-End': 'end-left',
  'Right-Center': 'center-right',
  'Right-Start': 'start-right',
  'Right-End': 'end-right',
} as const;

export const getPlacement = (
  direction: TooltipDirectionEnum = 'Top',
  alignment: TooltipAlignEnum = 'Center',
): Placement => {
  const basePlacement = direction.toLowerCase();
  return alignment === 'Center'
    ? basePlacement as Placement
    : `${basePlacement}-${alignment.toLowerCase()}` as Placement;
};
